import { useEffect } from 'react';

export const useDnDScroll = (scrollContainer: HTMLElement) => {
  useEffect(() => {
    if (!scrollContainer) return;

    const offset = scrollContainer.getBoundingClientRect().height * 0.15;
    const maxSpeed = 10;

    const getScrollSpeed = (y: number) => {
      const rect = scrollContainer.getBoundingClientRect();
      const distanceFromTop = y - rect.top;
      const distanceFromBottom = rect.bottom - y;

      let scrollSpeed = 0;

      if (distanceFromTop < offset) {
        scrollSpeed = Math.max(
          maxSpeed * ((offset - distanceFromTop) / offset),
          2
        );
        scrollSpeed = -Math.pow(scrollSpeed, 1.5);
      } else if (distanceFromBottom < offset) {
        scrollSpeed = Math.max(
          maxSpeed * ((offset - distanceFromBottom) / offset),
          2
        );
        scrollSpeed = Math.pow(scrollSpeed, 1.5);
      }

      return scrollSpeed;
    };

    // Desktop dragover
    const handleDragOver = (e: DragEvent) => {
      const scrollSpeed = getScrollSpeed(e.clientY);
      if (scrollSpeed !== 0) {
        scrollContainer.scrollBy(0, scrollSpeed);
      }
    };

    // Mobile touchmove
    const handleTouchMove = (e: TouchEvent) => {
      if (e.touches.length > 0) {
        const touch = e.touches[0];
        const scrollSpeed = getScrollSpeed(touch.clientY);
        if (scrollSpeed !== 0) {
          scrollContainer.scrollBy(0, scrollSpeed);
        }
      }
    };

    scrollContainer.addEventListener('dragover', handleDragOver);
    scrollContainer.addEventListener('touchmove', handleTouchMove);

    return () => {
      scrollContainer.removeEventListener('dragover', handleDragOver);
      scrollContainer.removeEventListener('touchmove', handleTouchMove);
    };
  }, [scrollContainer]);
};
